import { applySkipInput } from "@cloudnest/stone-flicking-core-engine/appliers";
import type { SkipFlickAction } from "../types/actions";
import type { StoneFlickingState } from "../types/game-state";
import { toParticipantId, wrapCoreState } from "../utils/state-mapper";

export function applySkipFlick(
  state: StoneFlickingState,
  action: SkipFlickAction,
): StoneFlickingState {
  const coreAction = {
    type: "SKIP_INPUT" as const,
    participantId: toParticipantId(action.playerId),
  };

  const nextCoreState = applySkipInput(state.coreState, coreAction);
  return wrapCoreState(nextCoreState);
}
